import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'getPropertyUrl',
})
export class GetPropertyUrlPipe implements PipeTransform {
  transform(urls: { id: number; url: string | null }[], propertyId: number): string {
    return urls.find((url) => url.id === propertyId)?.url || 'URL not set';
  }
}
